import { Link } from "@tanstack/react-router";
import { CompassIcon } from "lucide-react";
import { EmptyState } from "@/components/empty-state";
import { FullPage } from "@/components/full-page";
import { Button } from "@/components/ui/button";

function NotFoundBody() {
  return (
    <EmptyState
      icon={CompassIcon}
      title="Page not found"
      description="The page you're looking for doesn't exist or has moved."
      action={
        <Button asChild>
          <Link to="/">Go to Home</Link>
        </Button>
      }
    />
  );
}

/** Inside a layout (shell keeps rendering around it). */
export function NotFoundInline() {
  return (
    <div className="py-10">
      <NotFoundBody />
    </div>
  );
}

/** Top-level 404 with no layout. */
export function NotFoundPage() {
  return (
    <FullPage>
      <NotFoundBody />
    </FullPage>
  );
}
